
export const editProductEndpoint = (productId: string) =>
 (`/api/product/${productId}`);

export const getProductEndpoint = (category:string) =>(`/api/product/categoryName/${category}`);

export const getProductDetailsEndpoint = (productId: string) =>
 (`/api/product/${productId}`);

export const deleteProductEndpoint = (productId: string) =>
 (`/api/product/${productId}`);
export const addProductEndpoint = () => (`/api/product`);
export const getAllProductEp = ()=>('/api/product')